// extracted by mini-css-extract-plugin
export default {"draggable":"DraggableHTMLWaypoint--draggable--mTFD3","dragging":"DraggableHTMLWaypoint--dragging--14VXD"};